import { memo, useEffect, useRef } from 'react';
import type { Sight } from '../../types';
import { createScene } from '../../scene/createScene';
import type { SceneConfig } from '../../scene/sceneConfig';
import { sceneReady } from '../../state/appState';
import styles from './SceneCanvas.module.css';

interface SceneCanvasProps {
  sights: Sight[];
  config: SceneConfig;
}

function SceneCanvasComponent({ sights, config }: SceneCanvasProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const dispose = createScene({
      container: containerRef.current,
      sights,
      config,
      onReady: sceneReady,
    });

    return () => {
      dispose();
    };
  }, [sights, config]);

  return <div ref={containerRef} className={styles.canvasRoot} />;
}

export const SceneCanvas = memo(SceneCanvasComponent);
